import { showFailureToast, showSuccessToast } from "@helpers";
import { createAction, createSlice } from "@reduxjs/toolkit";

const createDiscountSlice = createSlice({
  name: "createDiscount",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      showSuccessToast("Create discount successful!");
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      showFailureToast("Create discount failed!");
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = createDiscountSlice;
const createDiscountAction = createAction(name);

export {
  createDiscountAction,
  actions as createDiscountActions,
  reducer as createDiscountReducer,
};
